import { Link } from 'react-router-dom';
import './Dashboards.css'
const Dashboards =  (props) => {
    return (
        <div className='dashboards'>
            <br></br>
            <br></br>
            <div className='dashboards-titulo'>
                <h2>Dashboards</h2>
            </div>
            <center>
                <br></br>
                <Link to={'/mapa'}><div className='botao_dash'>Semanal</div></Link>
                <br></br>
                <Link to={'/mapa2'}><div className='botao_dash'>Mensal</div></Link>
            </center>
        </div>
    )
};

export default Dashboards